//@flow
import TrackJs from './trackjs-interface';

// this js is useful enough for testing that I'm just going to leave it here
// commented out for future use.
// window.fbq = (a, b, c) => console.log(`fbq( '${a}', '${b}', ${JSON.stringify(c)} )`);

function _callFBQFunction(...args) {
  try {
    if (global.inServer || !global.fbq) return;
    global.fbq.apply(this, args);
  } catch (e) {
    TrackJs.console.debug(`error: ${e}`);
    TrackJs.track("FBQ error");
  }
}

export default {
  track(event:string, data:Object) {
    _callFBQFunction('track', event, data);
  },
};
